module.exports = __webpack_public_path__ + "img/prizeFour.a2885be8.png";